module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/mig-69efd839f9fc0fd28e3f75fc1f5d27bf.svg";